import LoaderBase from "_src/engine/loaders/loader_base";
import {readChunk} from "_src/engine/loaders/utils"

export default class PlnLoader extends LoaderBase{
  loadMain(buffer) {
    const chunkData = readChunk(buffer);
    const geometry = this.prepareGeometry(chunkData);
    return geometry;
  }
}
